module.exports = __webpack_public_path__ + "img/new_54.03968043.jpg";